import { render, staticRenderFns } from "./BlogReactionDetails.vue?vue&type=template&id=50529be1&scoped=true"
import script from "./BlogReactionDetails.vue?vue&type=script&lang=js"
export * from "./BlogReactionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50529be1",
  null
  
)

export default component.exports